import { qcopy, findObjIndexInArray, padZero, isHighGlu, isLowGlu, isNormalGlu } from '@u'
import { derrorFactory, errorFactory } from '@u/log'
import { _legalEventArray } from './bgExclusiveMixinUtil'
import { _bgSortOriginDataByDayList } from '@u/reportHelper'

const derror = derrorFactory('bgExclusiveMixin', false)
const error = errorFactory('bgExclusiveMixin', false)

export default {
  data() {
    return {
      boxPlot: [],
      firstChartMiddleDataList: [],
      legalDailyList: [],
      bgDailyTables: [],
      highEventArray: [],
      lowEventArray: []
    }
  },
  methods: {
    dailyBGGraphHelperGetTableData(oneDayList = []) {
      derror(`dailyBGGraphHelperGetTableData, oneDayList`, oneDayList)
      const rst = oneDayList.map(day => {
        const { bloodGlucoseRecord = [], date } = day || {}
        return Object.assign(qcopy(day), { list: bloodGlucoseRecord })
      })
      derror(`dailyBGGraphHelperGetTableData, rst`, rst)
      return rst
    },
    dailyBehaviorHelperGetHighEventData(data = {}) {
      const { threeChartData = {}} = data
      const { BgEventArray = {}} = threeChartData
      return _legalEventArray(BgEventArray.highArray)
    },
    dailyBehaviorHelperGetLowEventData(data = {}) {
      const { threeChartData = {}} = data
      const { BgEventArray = {}} = threeChartData
      return _legalEventArray(BgEventArray.lowArray)
    },
    dailyBehaviorHelperGetPieData(data = {}) {
      // derror(`dailyBehaviorHelperGetPieData`)
      const { threeChartData = {}} = data
      const { insulinChart } = threeChartData
      if (insulinChart && insulinChart.totalBasal !== undefined) {
        return [{
          value: insulinChart.totalBasal,
          name: 'Basal Rate'
        }, {
          value: insulinChart.totalBolus,
          name: 'Bolus'
        }] 
      } else {
        return []
      }
    },
  },
  computed: {
    sumValue() {
      const { multiDay } = this
      const { insulinChart = {}, NumberOfBgMeasurements = {}} = multiDay
      const { bgMean } = NumberOfBgMeasurements
      const { totalBasal, totalBolus } = insulinChart
      const totalInsulin = +totalBasal + +totalBolus
      
      return {
        insulin: (Number.isNaN(+totalInsulin)) ? '-' : (totalInsulin).toFixed(1),
        bolus: (Number.isNaN(+totalBolus)) ? '-' : (+totalBolus).toFixed(1),
        basal: (Number.isNaN(+totalBasal)) ? '-' : (+totalBasal).toFixed(1),
        mean: bgMean || '-'
      }
    },
    firstChartMiddleDataListWithoutNumber1() {
      const { firstChartMiddleDataList = [] } = this
      const rst = firstChartMiddleDataList
      return rst
    },
    bgMesurementWidth() {
      const { isLongLanguage } = this
      return isLongLanguage ? 725 : 625
    },
    bgDailyTableSummary() {
      const { dailyList = [] } = this
      
      // 将每一天的数据归类一下
      // step1, 将所有数据归类到24个小时间隔 0-1, 1-2, ...
      const sortedOriginDataByDayList = _bgSortOriginDataByDayList(dailyList)
      
      // 计算出总结性的一行
      const sum = {
        date: 'Amount',
        isSum: true,
        cell24: {}
      }
      
      for (let j = 0; j < 24; j++) {
        const key = `cell${j}`
        let minCount = 0
        let maxCount = 0
        
        /* *********遍历所有行，取出{j}时间段的数组，并计算********* */
        sortedOriginDataByDayList.forEach((oneDay, i) => {
          const { list: oneDayPerHourData, date } = oneDay
          
          oneDayPerHourData.forEach((record, k) => {
            if (k === j) {
              if (!Array.isArray(record)) {
                // 直接认为，没有数据
              } else {
                // 有数据
                const l = record.length
                
                /* ++++++++++计算高低血糖值数量++++++++++ */
                record.forEach(one => {
                  const isMin = isLowGlu(one['bloodGlucose'])
                  const isMax = isHighGlu(one['bloodGlucose'])
                  
                  if (isMin) {
                    minCount++
                  }
                  if (isMax) {
                    maxCount++
                  }
                })
                /* ++++++++++End of 计算高低血糖值数量++++++++++ */
              } 
            }
          })          
        })
        /* *********End of 遍历所有行，取出{j}时间段的数组，并计算********* */
        
        sum[key] = {
          min: minCount,
          max: maxCount
        }
      }
      
      sum[`cell24`] = undefined
      return sum
    }
  },
  mounted() {
  },
  beforeDestroy() {
  }
}
